export default () => ({
    video: null,
    isPlaying: false,
    isMuted: true,

    toggle() {
        const video = this.video

        if (video) {
            if (video.paused) {
                video.play()
            } else {
                video.pause()
            }
        }
    },

    toggleAudio() {
        const video = this.video

        if (video) {
            video.muted = !video.muted
        }
    },

    init() {
        this.video = this.$el.querySelector('video')

        if (this.video) {
            this.video.addEventListener('play', () => (this.isPlaying = true))
            this.video.addEventListener('pause', () => (this.isPlaying = false))
            this.video.addEventListener(
                'volumechange',
                () => (this.isMuted = this.video.muted)
            )
        }
    },
})
